/*
  Turns a long product description into scannable rows without touching the product data.
  Any heading in the description (h2-h4, or a paragraph that is only bold text) whose wording
  looks like a section title ("How to use", "Ingredients", "Key benefits"...) starts a collapsible row.
  Text before the first such heading stays visible as the intro. Without JS the full description shows.
*/
if (!customElements.get('description-sections')) {
  customElements.define(
    'description-sections',
    class DescriptionSections extends HTMLElement {
      connectedCallback() {
        const titleWords =
          /how to use|directions|how to apply|ingredients|inci|benefits|why (you|your|it|we|waterless)|who (it|is)|ideal for|perfect for|story|science|when to use|texture|results|routine|key botanicals|love it|good to know|note|avoid|patch test/i;
        // Some descriptions are pasted inside one wrapper <div>; look inside it so the headings are found.
        let root = this;
        while (root.children.length === 1 && root.children[0].tagName === 'DIV' && root.children[0].children.length > 1) {
          root = root.children[0];
        }
        const children = Array.from(root.children);
        // A heading is an h2-h4, or a paragraph/div whose whole text is bold (descriptions were
        // pasted in with <div><strong>Title</strong></div> or <p><span>Title</span></p> markup).
        const isHeading = (el) => {
          const tag = el.tagName;
          const text = el.textContent.trim();
          // Sentences (with full stops) are never titles, however they are formatted
          if (!text || text.length > 70 || /\.\s|\.$/.test(text)) return null;
          let looksLikeTitle = /^H[2-4]$/.test(tag);
          if (!looksLikeTitle && /^(P|DIV)$/.test(tag)) {
            const bold = el.querySelector('strong, b');
            if (bold && bold.textContent.trim() === text) looksLikeTitle = true;
            else if (el.children.length === 1 && el.children[0].tagName === 'SPAN' && el.children[0].textContent.trim() === text) looksLikeTitle = true;
            // Plain short line that reads as a section title ("Key Benefits", "How to use:", "Ingredients;")
            else if (
              text.length <= 45 &&
              !/[.!?]$/.test(text) &&
              /^(why|key|how|what|ingredients|inci|perfect for|ideal for|texture|please note|top notes|heart notes|base notes|overall scent|aftercare|directions|size|who|when|results|good to know|benefits)/i.test(text)
            ) looksLikeTitle = true;
          }
          if (!looksLikeTitle || text.length < 3 || !titleWords.test(text)) return null;
          return text.replace(/[:;\s]+$/, '');
        };
        const groups = [];
        let current = null;
        children.forEach((el) => {
          const title = isHeading(el);
          if (title) {
            current = { title: title, nodes: [] };
            groups.push(current);
          } else if (current) {
            current.nodes.push(el);
          }
        });
        if (groups.length < 2) return;

        const frag = document.createDocumentFragment();
        groups.forEach((g, i) => {
          if (!g.nodes.length) return;
          const details = document.createElement('details');
          details.className = 'product__accordion-row';
          details.id = 'DescriptionRow-' + i;
          const summary = document.createElement('summary');
          const h = document.createElement('h2');
          h.className = 'h4 accordion__title';
          h.textContent = g.title;
          summary.appendChild(h);
          summary.insertAdjacentHTML('beforeend', this.dataset.caret || '');
          details.appendChild(summary);
          const body = document.createElement('div');
          body.className = 'accordion__content rte';
          g.nodes.forEach((n) => body.appendChild(n));
          details.appendChild(body);
          frag.appendChild(details);
        });
        // Remove the heading elements that became row titles, keep the intro in place.
        children.forEach((el) => {
          if (isHeading(el)) el.remove();
        });
        const wrap = document.createElement('div');
        wrap.className = 'product__accordion accordion product__description-rows';
        wrap.appendChild(frag);
        this.appendChild(wrap);
        this.classList.add('is-split');
      }
    }
  );
}
